import Vue from 'vue';

import { CourseId } from '@/openapi/enum';




export type Course = {
  id: CourseId;
  name: string;
};

export default Vue.extend({

  name: 'CourseMixin',

  data(): {
    readonly courses: Course[];
  } {
    return {
      courses: [
        {
          id: CourseId.word,
          name: 'ことば'
        },
        {
          id: CourseId.japanese,
          name: '読解'
        },
        {
          id: CourseId.number,
          name: 'すうじ'
        },
        {
          id: CourseId.calc,
          name: '計算'
        },
      ],
    };
  },

});
